import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const addNewData = createAsyncThunk(
  "edos/addNewData",
  async ({ newData, navigate, toast }, { rejectWithValue }) => {
    try {
      const response = await api.AddForm(newData);
      toast.success("Form Submitted Successfully");
      navigate("/");
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const edosSlice = createSlice({
    name: "edos",
    initialState: {
        edosList: [],
        error: '',
        loading:false,
        cartItemList: JSON.parse(sessionStorage.getItem("cartValues")) || []
    },
    reducers:{
      cartReducer: (state, action) => {
        state.cartItemList = action.payload;
      },
    },
    extraReducers: {
    [addNewData.pending]: (state, action) => {
      state.loading = true;
    },
    [addNewData.fulfilled]: (state, action) => {
      state.loading = false;
      state.edosList = [action.payload];
    },
    [addNewData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    },
}
})

export const {cartReducer} = edosSlice.actions;

export default edosSlice.reducer;